import React from 'react';
import { useUserContext } from './UserProvider';
import { DefaultService } from '../generated/api';
import { useAuthContext } from './AuthProvider';
import { Audio } from 'expo-av';
import { useInterval } from '../utils/helpers/useInterval';
import differenceBy from 'lodash/differenceBy';
import { StatusEnum } from '../types/enums/StatusEnum';
import getLastCategoryDataFromCategoriesPath from '../utils/helpers/getLastCategoryDataFromCategoriesPath';
import { doestItHaveChildren } from '../utils/helpers/doestItHaveChildren';

interface UserDemandsContextType {
  demandsState: any;
}

const DemandsContext = React.createContext<UserDemandsContextType>({} as UserDemandsContextType);

const DemandsProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [demandsState, setDemandState] = React.useState<any>([]);
  const [delay, setDelay] = React.useState<number | null>(5000);
  const userContext = useUserContext();
  const authContext = useAuthContext();
  useInterval(async () => {
    await getDataAndPlayNotif();
  }, delay);

  async function playUrgentSound() {
    const { sound } = await Audio.Sound.createAsync(require('../assets/audios/requete_urgente.mp3'));

    await sound.playAsync();
  }

  async function playNormalSound() {
    const { sound } = await Audio.Sound.createAsync(require('../assets/audios/requete_normale.mp3'));

    await sound.playAsync();
  }

  async function getDataAndPlayNotif() {
    if (
      !authContext.authState.isConnected ||
      !authContext.authState.token ||
      !userContext.userState.profile?.currentDepartment
    )
      return;

    const newData = await DefaultService.getDepartmentDemandsCaregiver(
      `Bearer ${authContext.authState.token}`,
      userContext.userState.profile?.currentDepartment
    );

    if (JSON.stringify(newData.records) !== JSON.stringify(demandsState)) {
      setDemandState(() => newData.records);

      let shouldPlaySound = false;
      let shouldPlayUrgentSound = false;
      const diffId = differenceBy(newData.records, demandsState, 'ID');
      const diffStatus = differenceBy(newData.records, demandsState, 'status');

      if (diffId.length > 0) {
        diffId.forEach((demand: any) => {
          let category;
          let parentCategory;
          if (doestItHaveChildren(demand.category)) {
            const parsedCategories = getLastCategoryDataFromCategoriesPath(
              demand.category,
              doestItHaveChildren(demand.category)
            );
            category = parsedCategories.category;
            parentCategory = parsedCategories.parentCategory;
          } else {
            category = demand.category;
          }

          console.log('category', category)
          console.log('parentCategory', parentCategory)
          if (
            demand.status === StatusEnum.NEW ||
            demand.status === StatusEnum.BOOSTED ||
            demand.status === StatusEnum.REBOOSTED
          ) {
            shouldPlaySound = true;
            if(category.priority === 1){
              shouldPlayUrgentSound = true;
            } 
          }
        });
      }

      if (diffStatus.length > 0) {
        diffStatus.forEach((demand: any) => {
          let category;
          let parentCategory;
          if (doestItHaveChildren(demand.category)) {
            const parsedCategories = getLastCategoryDataFromCategoriesPath(
              demand.category,
              doestItHaveChildren(demand.category)
            );
            category = parsedCategories.category;
            parentCategory = parsedCategories.parentCategory;
          } else {
            category = demand.category;
          }

          if (
            demand.status === StatusEnum.NEW ||
            demand.status === StatusEnum.BOOSTED ||
            demand.status === StatusEnum.REBOOSTED
          ) {
            shouldPlaySound = true;
            if(category.priority === 1){
              shouldPlayUrgentSound = true;
            } 
          }
        });
      }

      console.log('shouldPlaySound', shouldPlaySound)
      console.log('shouldPlayUrgentSound', shouldPlayUrgentSound)
      if(shouldPlaySound){
        if(shouldPlayUrgentSound){
          playUrgentSound();
        }
        else{
        playNormalSound();
        }
      }
    }
  }

  React.useEffect(() => {
    if (
      !authContext.authState.isConnected ||
      !authContext.authState.token ||
      !userContext.userState.profile?.currentDepartment
    ) {
      setDelay(null);
    } else {
      setDelay(5000);
    }
  }, [
    authContext.authState.isConnected,
    authContext.authState.token,
    userContext.userState.profile?.currentDepartment,
  ]);

  return (
    <DemandsContext.Provider
      value={{
        demandsState,
      }}
    >
      {children}
    </DemandsContext.Provider>
  );
};

const useDemandsContext = (): UserDemandsContextType => {
  return React.useContext(DemandsContext);
};

export { DemandsProvider, useDemandsContext };
